<template>
  <span
    class="backTop el-icon-upload2"
    :class="showBackTop ? 'isShow' : ''"
    @click="clickEvent()"
  ></span>
</template>

<script>
export default {
  name: 'backTop',
  props: {
    showBackTop: {
      type: Boolean,
      default: false,
    },
    clickEvent: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.backTop {
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 7.25vw;
  right: 3.125vw;
  z-index: 1000;
  width: 3.47vw;
  height: 3.47vw;
  border-radius: 50%;
  background-color: var(--mixtmt_whiteColor);
  border: 1px solid var(--mixtmt_greyColor7);
  color: var(--mixtmt_greyColor6);
  font-size: 0;
  opacity: 0;
  transition: all 0.3s linear;

  &.isShow {
    font-size: 1.66vw;
    opacity: 1;
  }
  &:hover {
    cursor: pointer;
    background-color: var(--mixtmt_mainColor);
    border: 1px solid var(--mixtmt_mainColor);
    color: var(--mixtmt_whiteColor);
  }
}
</style>
